import { GET_DELIVERY_JOB_COUNT_USER, GET_REQUESTOR_JOB_COUNT_USER, GET_USERS_LIST } from "../../data/APIEndpoints";
import axios from "../AxiosInstance";

const fetchUserList = async (roleId, pageNumber, pageCount, searchParams, filterParams) => {
  let url =
    GET_USERS_LIST +
    `?RoleId=${roleId}&PageNumber=${pageNumber}&PageCount=${pageCount}`;
  if (searchParams) {
    url = url + `&SearchString=${searchParams}`;
  }
  if(filterParams?.sortBy) {
    url = url + `&FilterValue=${filterParams?.sortBy}`;
  }

  try {
    const response = await axios.get(url);
    if (response.status === 200 || response.status === 201) {
      return { status: "success", data: response.data };
    }
  } catch (error) {
    return {
      status: "error",
      message: "An error occurred while processing the data.",
      error: error,
    };
  }
};

const getUserDeliveryListingCount = async (userId) => {
  const url = GET_DELIVERY_JOB_COUNT_USER + `?userId=${userId}`;
  try {
    const response = await axios.get(url);

    if (response.status === 200) {
      return { status: "success", data: response.data };
    }
  } catch (error) {
    return {
      status: "error",
      message: "Failed to Load Listing Count",
      error: error,
    };
  }
};

const getUserRequestorListingCount = async (userId) => {
  const url = GET_REQUESTOR_JOB_COUNT_USER + `?userId=${userId}`;
  try {
    const response = await axios.get(url);

    if (response.status === 200) {
      return { status: "success", data: response.data };
    }
  } catch (error) {
    return {
      status: "error",
      message: "Failed to Load Listing Count",
      error: error,
    };
  }
};

const UserListAPI = {
  fetchUserList,
  getUserRequestorListingCount,
  getUserDeliveryListingCount,
};

export default UserListAPI;
